import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, errMsg } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = unknown, false = logged out, object = logged in
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      if (data?.authenticated) {
        setUser({ id: data.id, email: data.email, name: data.name, loyalty_points: data.loyalty_points, role: data.role });
      } else {
        setUser(false);
      }
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.token) localStorage.setItem("kavo_token", data.token);
    setUser({ id: data.id, email: data.email, name: data.name, loyalty_points: data.loyalty_points, role: data.role });
    return data;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    if (data?.token) localStorage.setItem("kavo_token", data.token);
    setUser({ id: data.id, email: data.email, name: data.name, loyalty_points: data.loyalty_points, role: data.role });
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("kavo_token");
    setUser(false);
  };

  const refreshMe = fetchMe;

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshMe, errMsg }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
